import { Host, h } from '@stencil/core';
export class AibaKritiqueScript {
  constructor() {
    this.handleLoadScriptKritique = async () => {
      var _a, _b, _c, _d;
      const scriptPresent = typeof window !== 'undefined' && window.kritiqueInitialized;
      if (!scriptPresent) {
        //create Kritique script & push in DOM
        const script = document.createElement('script');
        script.src = `${(_a = this.kritiqueData) === null || _a === void 0 ? void 0 : _a.url}?brandid=${(_b = this.kritiqueData) === null || _b === void 0 ? void 0 : _b.brandId}&localeid=${(_c = this.kritiqueData) === null || _c === void 0 ? void 0 : _c.localeId}&apikey=${(_d = this.kritiqueData) === null || _d === void 0 ? void 0 : _d.apikey}`;
        script.id = 'rr-kritique-widget';
        typeof window !== 'undefined' ? (!window.kritiqueInitialized ? document.body.appendChild(script) : null) : null;
        await document.querySelector('#rr-kritique-widget');
      }
    };
    this.upc = undefined;
    this.kritiqueData = undefined;
  }
  componentDidLoad() {
    this.handleLoadScriptKritique();
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get is() { return "aiba-kritique-script"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-kritique-script.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-kritique-script.css"]
    };
  }
  static get properties() {
    return {
      "upc": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upc",
        "reflect": false
      },
      "kritiqueData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "kritique-data",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-kritique-script.js.map
